<template>
  <div>
    <div class="tabnavBox">
      <transition-group name="list" tag="ul">
        <li
          v-for="(item, index) in $store.getters.tabnavBox"
          @contextmenu.prevent="openMenu(item, $event, index)"
          :key="item.title"
          class="tabnav"
          :class="{ active: $route.path === item.path }"
        >
          <router-link :to="{ path: item.path }">{{
            $t(`routeName.${item.title}`)
          }}</router-link>
          <i
            @click="removeTab(item)"
            class="el-icon-error"
            v-if="index !== 0"
          ></i>
        </li>
      </transition-group>
    </div>
    <!-- removeTab关闭，关闭其他，全部关闭按钮 -->
    <ul
      v-show="this.rightMenuShow"
      :style="{ left: this.left + 'px', top: this.top + 'px' }"
      class="menuBox"
    >
      <li @click="removeTab($store.getters.rightNav)">
        <i class="fa fa-remove"></i>
        {{ $t("rightMenu.close") }}
      </li>
      <li @click="removeOtherTab($store.getters.rightNav)">
        {{ $t("rightMenu.closeOther") }}
      </li>
      <li @click="removeAllTab">{{ $t("rightMenu.closeAll") }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "tabNav",
  data() {
    return {
      rightMenuShow: false,
      left: 0,
      top: 0,
    };
  },
  methods: {
    //item 获取左侧栏每个标题的路径和值
    //index 获取左侧栏每个标题的下标
    openMenu(item, e, index) {
      if (index === 0) {
        return false;
      }
      this.rightMenuShow = true; //关闭，关闭其他--弹窗显示
      this.left = e.clientX + 10;
      this.top = e.clientY;
      this.$store.dispatch("openMenu", item);
    },
    //关闭
    removeTab(tabItem) {
      this.$store.commit("addExcludedComponents", tabItem.title);
      // fullPath匹配路由
      this.$store.dispatch("removeTab", {
        tabItem,
        fullPath: this.$route.fullPath,
        router: this.$router,
      });
    },
    //关闭其他
    removeOtherTab(tabItem) {
      // dispatch：异步操作，向后台提交数据，写法： this.$store.dispatch('action方法名',值)
      // commit：同步操作，写法：this.$store.commit('mutations方法名',值)
      this.$store.dispatch("removeOtherTab", {
        tabItem,
        router: this.$router,
      });
    },
    //关闭全部
    removeAllTab() {
      this.$store.dispatch("removeOtherTab", {
        all: true,
        router: this.$router,
      });
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
  },
  mounted() {},
  watch: {
    rightMenuShow(value) {
      if (value) {
        // document.body.addEventListener添加事件
        document.body.addEventListener("click", () => {
          this.rightMenuShow = false;
        });
      } else {
        // document.body.addEventListener移除事件
        document.body.removeEventListener("click", () => {
          this.rightMenuShow = false;
        });
      }
    },
  },
};
</script>
<style>
.tabnav {
  display: inline-block;
  transition: all 0.5s;
}

.list-enter,
	.list-leave-to

	/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.list-enter-active {
  transition: all 0.5s;
}

.list-leave-active {
  position: absolute;
  transition: all 1s;
}
</style>
<style lang="scss">
$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);

%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}
%wh100 {
  width: 100%;
  height: 100%;
}
%cursor {
  cursor: pointer;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}
.menuBox {
  margin: 0;
  background: #fff;
  z-index: 999;
  position: absolute;
  padding: 5px 0;
  // border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 1px 6px 0 rgba(0, 0, 0, 0.3);
  li {
    margin: 0;
    padding: 7px 16px;
    @extend %cursor;
    &:hover {
      background: #e1e6ea;
    }
  }
}

$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);

%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}

.tabnavBox {
  @extend %w100;
  height: 40px;
  min-height: 40px;
  overflow: hidden;
  background: #e1e7ee;

  ul {
    display: flex;
    justify-content: flex-start;
    padding-#{$left}: 20px;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-#{$top}: 3px;
    li {
      height: 30px;
      line-height: 30px;
      @extend %cursor;
      margin-#{$right}: 5px;
      overflow: hidden;
      min-width: 50px;
      background: #f7fbff;
      &:not(:first-child) {
        padding-#{$right}: 10px;
        min-width: 80px;
      }
      a {
        @include set-value(padding, 13px);
        display: inline-block;
        @extend %wh100;
        font-size: 12px;
        color: #999;
        min-width: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: bold;
      }

      &:nth-child(n + 2) {
        a {
          padding-#{$right}: 15px;
        }
      }

      i {
        @extend %cursor;
        &:hover {
          color: red;
        }
      }
    }
    li.active {
      font-weight: bold;
      color: #61a7cf;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px 4px 0px 0px;
      min-width: 60px;
      &:not(:first-child) {
        min-width: 80px;
      }
      a {
        color: #61a7cf;
      }
    }
  }
}
.tabnav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/header/tabNav.vue